module.exports = __webpack_public_path__ + "img/75Bar.c103f9ac.svg";